import React from 'react';
import { Grid, Paper, Typography, Skeleton, Tooltip } from '@mui/material';
import { BarChart, Bar, XAxis, YAxis, Tooltip as RechartsTooltip, ResponsiveContainer } from 'recharts';

const COLORS = ['#1976d2', '#ef5350', '#ffa726'];

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;

  const { payload: data } = payload[0];

  return (
    <Paper elevation={3} sx={{ p: 1 }}>
      <Typography variant="subtitle2">{data.product}</Typography>
      <Typography variant="body2">Stock: {data.stock}</Typography>
    </Paper>
  );
};


const LowStockChart = ({ title, data, color, loading }) => {
  const sortedData = [...data]
    .sort((a, b) => a.stock - b.stock)
    .slice(0, 10); // 👈 límite seguro

  return (
    <Paper elevation={2} sx={{ p: 2, height: 340 }}>
      <Typography variant="subtitle1" gutterBottom>{title}</Typography>
      {loading ? (
        <Skeleton variant="rectangular" height={300} />
      ) : (
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={sortedData} layout="vertical" margin={{ top: 10, left: 0, right: 10, bottom: -10 }}>
            <XAxis type="number" hide />
            <YAxis
              type="category"
              dataKey="product"
              tick={{
                fontSize: 12,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
              tickFormatter={(value) => value.length > 18 ? value.slice(0, 18) + '…' : value}
              width={120}
            />
            <RechartsTooltip content={<CustomTooltip />} />
            <Bar dataKey="stock" fill={color} />
          </BarChart>
        </ResponsiveContainer>
      )}
    </Paper>
  );
};

const LowStockByBranchGrid = ({ data, branches = [], loading }) => {
  if (!data || !branches?.length) return null;

  return (
    <Grid container spacing={2} mt={0}>
      {branches.map((branch, index) => (
        <Grid item xs={12} md={4} key={branch.id}>
          <LowStockChart
            title={`📉 Bajo stock – ${branch.name}`}
            data={data[branch.id] || []}
            color={branch.color || COLORS[index % COLORS.length]}
            loading={loading}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default LowStockByBranchGrid;
